import React from 'react';
import { Book, BookStatus } from '../interfaces.ts';
import { useNavigate } from 'react-router-dom';

interface BookListProps {
  books: Book[];
  statuses: BookStatus[];
  searchTerm: string; // 新增 searchTerm 屬性
}

const BookList: React.FC<BookListProps> = ({ books, statuses, searchTerm }) => {
  const navigate = useNavigate();

  const getStatusName = (statusCode: string) => {
    const status = statuses.find(s => s.status_code === statusCode);
    return status ? status.status_name : '未知';
  };

  return (
    <div style={{ width: '100%' }}>
      <h2 style={{ marginBottom: '15px' }}>書籍列表</h2>
      {books.length === 0 && searchTerm !== '' ? (
        <p>沒有找到書籍。</p>
      ) : books.length === 0 && searchTerm === '' ? (
        <p></p> // 當 searchTerm 為空時，不顯示任何內容
      ) : (
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead>
            <tr style={{ borderBottom: '1px solid #ddd' }}>
              <th style={{ padding: '8px', textAlign: 'center' }}>書名</th>
              <th style={{ padding: '8px', textAlign: 'center' }}>狀態</th>
            </tr>
          </thead>
          <tbody>
            {books.map((book) => (
              <tr
                key={book.id}
                onClick={() => navigate(`/book/${book.id}`)}
                style={{ cursor: 'pointer', borderBottom: '1px solid #eee' }}
              >
                <td style={{ padding: '8px', textAlign: 'left' }}>{book.name}</td>
                <td style={{ padding: '8px', textAlign: 'left' }}>{getStatusName(book.status_code)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default BookList;